function stringifyPublisher(publisher) {
  switch (publisher) {
    case "hans-reitzel":
      return "Hans Reitzel";
    case "munksgaard":
      return "Munksgaard";
    case "systime":
      return "Systime";
    default:
      return "Gyldendal";
  }
}

export { stringifyPublisher };
//# sourceMappingURL=util.stringify-publisher.js.map
